import { Dropdown, Button, Tooltip, message } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { exportarEntregasExcel } from "./EntregasExportarButton";
import { getEntregasExport } from "../../../../services/financiero/finEntregasService";
import { getInformeUnoaUno } from "../../../../services/financiero/finInformeUnoaUno";
import { exportarParticipantesEntregasExcel } from "./ParticipantesEntregasExportButton";
import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import dayjs from "dayjs";
import { useState } from "react";

export default function ExportarExcelDropdown({ filters }) {

  const [loading, setLoading] = useState(false);

  const exportarEntregas = async () => {
    try {
      setLoading(true);
      // La tabla está paginada: el Excel pide al servidor todas las entregas
      // que cumplen los filtros actuales.
      const data = await getEntregasExport(filters);
      await exportarEntregasExcel(data || []);
    } catch (error) {
      console.error(error);
      message.error("Error exportando entregas");
    } finally {
      setLoading(false);
    }
  };

  const exportarParticipantes = async () => {
    try {
      setLoading(true);
      await exportarParticipantesEntregasExcel(filters?.proyecto || []);
    } finally {
      setLoading(false);
    }
  };

  const exportarInformeUnoAUno = async () => {
    try {
      setLoading(true);
      const res = await getInformeUnoaUno(filters?.proyecto || []);
      const datos = res.data || [];
      if (!datos.length) {
        message.warning("No hay datos para exportar");
        return;
      }
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Informe Uno a Uno");
      worksheet.columns = [
        { header: "Símbolo del proyecto", key: "simbolo" },
        { header: "Nombre", key: "nombre_proyecto" },
        { header: "Nombre del participante", key: "nombre_entrega" },
        { header: "Departamento", key: "departamento" },
        { header: "Municipio", key: "municipio" },
        { header: "Documento de identificación", key: "identificacion" },
        { header: "Género", key: "sexo" },
        { header: "# PO", key: "Numero_PO" },
        { header: "Id Producto", key: "oid_producto" },
        { header: "Nombre Producto", key: "nombre_producto" },
        { header: "N° Acta de entrega", key: "carpeta" },
        { header: "Responsable recibo a satisfacción (supervisor/a de zona)", key: "responsable" },
        { header: "Cantidad", key: "cantidad" },
        { header: "Precio", key: "valor_unitario_COP" },
        { header: "Total entrega", key: "precio_total_COP" },
        { header: "Fecha Entrega", key: "fecha_entrega" },
        { header: "Tipo Entrega", key: "tipo_entrega_texto" },
        { header: "Entrega CC/NIT", key: "EntregaCCNit" },
        { header: "Codigo proyecto", key: "codigo" },
        { header: "Nombre del proyecto", key: "proyecto" },
        { header: "Categoría", key: "estado_soporte" },
        { header: "Observación", key: "observacion" },
      ];
      const headerColors = [
        "FFED7D31", "FFED7D31",
        "FF00B050",
        "FF00B0F0", "FF00B0F0", "FF00B0F0", "FF00B0F0",
        "FF4472C4", "FF4472C4", "FF4472C4", "FF4472C4", "FF4472C4", "FF4472C4", "FF4472C4",
        "FF00B0F0",
        "FF4472C4",
        "FFED7D31",
        "FF4472C4", "FF4472C4", "FF4472C4",
        "FF00B050", "FF00B050"
      ];
      const headerRow = worksheet.getRow(1);
      headerRow.eachCell((cell, colNumber) => {
        cell.font = {
          bold: true,
          color: { argb: "FFFFFFFF" }
        };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: headerColors[colNumber - 1] }
        };
        cell.alignment = {
          horizontal: "center",
          vertical: "middle",
          wrapText: true
        };
      });
      datos.forEach(row => {
        worksheet.addRow({
          simbolo: "UTF/COL/160/COL",
          nombre_proyecto: "Implementar actividades de desarrollo económico, derecho humano a la alimentación y fortalecimiento de capacidades institucionales, comunitarias y organizacionales que aporten al cierre de brechas y la transformación de los territorios PDET",
          nombre_entrega: row.nombre_entrega,
          departamento: row.departamento || "",
          municipio: row.municipio || "",
          identificacion: row.identificacion,
          sexo: row.sexo || "N/A",
          Numero_PO: row.Numero_PO,
          oid_producto: row.oid_producto,
          nombre_producto: row.nombre_producto ? row.nombre_producto.charAt(0).toUpperCase() + row.nombre_producto.slice(1).toLowerCase() : "",
          carpeta: row.carpeta,
          responsable: row.responsable,
          cantidad: Number(row.cantidad),
          valor_unitario_COP: Number(row.valor_unitario_COP),
          precio_total_COP: Number(row.precio_total_COP),
          fecha_entrega: row.fecha_entrega ? dayjs(row.fecha_entrega).format("DD/MM/YYYY") : "",
          tipo_entrega_texto: row.tipo_entrega_texto,
          EntregaCCNit: row.EntregaCCNit,
          codigo: row.codigo,
          proyecto: row.proyecto,
          estado_soporte: row.estado_soporte,
          observacion: row.observacion
        });

      });
      worksheet.columns.forEach(column => {
        let maxLength = 10;
        column.eachCell({ includeEmpty: true }, cell => {
          const value = cell.value ? cell.value.toString() : "";
          maxLength = Math.max(maxLength, value.length);
        });
        column.width = maxLength + 2;
      });
      worksheet.eachRow({ includeEmpty: true }, (row) => {
        row.eachCell({ includeEmpty: true }, (cell) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" }
          };
        });
      });
      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber === 1) return;
        row.eachCell((cell, colNumber) => {
          const centerCols = [6, 7, 8, 12, 13, 14, 15, 16];
          cell.alignment = {
            vertical: "middle",
            horizontal: centerCols.includes(colNumber)
              ? "center"
              : "left"
          };
        });
      });
      worksheet.getColumn("valor_unitario_COP").numFmt = '"$"#,##0';
      worksheet.getColumn("precio_total_COP").numFmt = '"$"#,##0';
      worksheet.views = [
        { state: "frozen", ySplit: 1 }
      ];
      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(
        new Blob([buffer]),
        `Informe_Uno_A_Uno_${dayjs().format("YYYYMMDD_HHmm")}.xlsx`
      );
    } catch (error) {
      console.error(error);
      message.error("Error generando informe");
    } finally {
      setLoading(false);
    }
  };

  const items = [
    { key: "1", label: "Exportar Entregas", onClick: exportarEntregas },
    { key: "2", label: "Exportar Informe Uno a Uno", onClick: exportarInformeUnoAUno },
    { key: "3", label: "Exportar Participantes y Organizaciones con Entregas", onClick: exportarParticipantes }
  ];

  return (
    <Dropdown menu={{ items }} placement="bottomRight">
      <Tooltip title="Exportar reportes a Excel">
        <Button icon={<DownloadOutlined />} loading={loading}>
          
        </Button>
      </Tooltip>
    </Dropdown>
  );
}